import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import { ToastContainer, toast } from 'react-toastify';
import validator from 'validator';
import Lottie from 'react-lottie';

import api from '../../services/api';
import 'react-toastify/dist/ReactToastify.css';
import { ContainerLogin, ContainerLoading } from './style.js';
import logo from '../../assets/logo-final-horizontal.png';
import Loading from '../../assets/loading.json';

const Login = () => {
  document.title = 'Enermerco - Administrador';

  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [email, setEmail] = useState('marcelo@datamais.com.br');
  const [password, setPassword] = useState('D@tamais');

  const loadingAnimation = {
    loop: true,
    autoplay: true,
    animationData: Loading
  };

  const loginValidation = async () => {
    setIsLoading(true);
    if (validator.isEmail(email)) {
      if (password !== '') {
        const dataAuth = {
          email: email,
          password
        };
        api
          .post('signin', dataAuth)
          .then((response) => {
            console.log(response);
            if (response.token !== '' && response.data.user.type === '1') {
              localStorage.setItem('id', response.data.user.id);
              localStorage.setItem('TOKEN', response.data.token);
              localStorage.setItem('email', email);
              setIsLoading(false);
              toast.success('Login efetuado com sucesso!');
              navigate('/study/list');
            } else {
              setIsLoading(false);
              toast.error('Erro, login incorreto!');
            }
          })
          .catch((err) => {
            setIsLoading(false);
            toast.error(`${err.response.data.message}`);

            console.log(err);
          });
      } else {
        toast.error('Senha inválida/vazia!');
      }
    } else {
      setIsLoading(false);
      toast.error('E-mail em formato inválido!');
    }
  };

  return (
    <>
      {isLoading ? (
        <ContainerLoading>
          <Lottie options={loadingAnimation} style={{ width: '100%', height: 400 }} />
          <h1>Efetuando Login...</h1>
        </ContainerLoading>
      ) : (
        <Container>
          <ContainerLogin>
            <div id="loginForm">
              <div className="logo">
                <img src={logo} alt="" />
              </div>
              <div>
                <input
                  type="text"
                  placeholder="E-mail"
                  onChange={(e) => setEmail(e.target.value)}
                  onKeyUp={(e) => {
                    if (e.key === 'Enter') {
                      loginValidation();
                    }
                  }}
                />
              </div>
              <div>
                <input
                  type="password"
                  placeholder="Senha"
                  onChange={(e) => setPassword(e.target.value)}
                  onKeyUp={(e) => {
                    if (e.key === 'Enter') {
                      loginValidation();
                    }
                  }}
                />
              </div>
              <div>
                <button id="btnLogin" onClick={loginValidation}>
                  ENTRAR
                </button>
              </div>
            </div>
          </ContainerLogin>
        </Container>
      )}
      <ToastContainer />
    </>
  );
};

export default Login;
